module.exports = __webpack_public_path__ + "img/1F1ED-1F1F9.edc66e82.svg";